import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}`;

export const projectSections = {
  'app.projectSections': (pId=':projectId') => `${prefix}/projects/${pId}/sections`,
  'app.projectSection':  (pId=':projectId', sId=':sectionId') => `${prefix}/projects/${pId}/sections/${sId}`,
};
